var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DPEnviromentTableMenu',{on:{"methodEnum":_vm.methodEnum,"keywords":_vm.changeKeywords}}),_c('DPEnviromentTable',{ref:"dpEnviromentTable"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }